<shell-layout [error_identity]="true">
  <img class="m-auto" src="assets/img/errors/error__security.svg" alt="" />
  <ui-text color="blue-500" size="h4" weight="semibold" align="center" class="mt-6">
    Algo no funcionó entre nosotros
  </ui-text>
  <ui-text color="blue-300" align="center" class="mt-3">
    Danos una segunda oportunidad.
  </ui-text>
  <div class="flex justify-center mt-10">
    <ui-button
      (clicked)="closeModal()"
      type="primary"
      label="Reintentar ahora"
    ></ui-button>
  </div>
</shell-layout>
